<template>
  <div class="card shadow search-card">
    <div class="row g-0 h-100">
      <div class="col-3 d-flex align-items-center justify-content-center">
        <div class="p-3">
          <img
            class="img-fluid"
            v-if="offer.provider_image"
            :alt="offer.provider_image_description"
            :src="`${offer.provider_image_url}`"
          >
          <img
            v-else
            width="50"
            aria-hidden="true"
            :src="categoryIconFor(offer.category_id)"
          >
        </div>
      </div>

      <div class="col-9">
        <div class="card-body">
          <span v-if="isNewOffer" class="badge bg-light text-dark text-uppercase me-2 mb-2">New</span>
          <span v-if="offer.expiring_offer" class="badge bg-light text-dark text-uppercase mb-2">Expiring soon</span>
          <p class="card-text mb-1">
            <small class="text-muted"> {{ offer.provider }} </small>
           </p>
           <h4 class="card-title">
             <a :href="'/offers/' + offer.id" class="stretched-link text-dark">
               <strong>{{ offer.amount }}</strong>
               {{ offer.headline }}
             </a>
           </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isNewOffer() {
      if (!this.offer.start_date) {
        return false;
      }
      
      const startDate = moment(this.offer.start_date);
      const thirtyDaysAgo = moment().subtract(30, 'days');
      
      return startDate.isAfter(thirtyDaysAgo);
    },
  },
  methods: {
    categoryIconFor(category_id) {
      var categoryIcon = new URL(`../../images/icons/categories/${category_id}.svg`, import.meta.url).href;
      const urlParts = categoryIcon.split('/');
      if (urlParts[urlParts.length-1] == 'undefined') {
        categoryIcon =  new URL('../../images/icons/categories/no-logo-placeholder.svg', import.meta.url).href;
      }
      return categoryIcon;
    },
  },
};
</script>
